/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for data providers type.
 * @export
 * @interface DataProvider
 */
export interface DataProvider {
    /**
     * 
     * @type {string}
     * @memberof DataProvider
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof DataProvider
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataProvider
     */
    readonly secondaryDataSources: Array<string>;
}

/**
 * Check if a given object implements the DataProvider interface.
 */
export function instanceOfDataProvider(value: object): value is DataProvider {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if ((!('secondaryDataSources' in (value as Record<string, any>)) && !('secondary_data_sources' in (value as Record<string, any>))) || ((value as Record<string, any>)['secondaryDataSources'] === undefined && (value as Record<string, any>)['secondary_data_sources'] === undefined)) return false;
    return true;
}

export function DataProviderFromJSON(json: any): DataProvider {
    return DataProviderFromJSONTyped(json, false);
}

export function DataProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataProvider {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'secondaryDataSources': json['secondary_data_sources'],
    };
}

export function DataProviderToJSON(json: any): DataProvider {
    return DataProviderToJSONTyped(json, false);
}

export function DataProviderToJSONTyped(value?: Omit<DataProvider, 'id'|'secondaryDataSources'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

